import { HeroTitle } from '@/components/marketing/hero-title'
import {
  NewsroomFeaturedCard,
  NewsroomTable,
} from '@/components/marketing/press-release-layout'
import {
  featuredNewsroomItem,
  newsroomItems,
} from '@/config/marketing-content/newsroom-items.config'

export function NewsroomPage() {
  return (
    <main className="newsroom">
      <section className="newsroom-hero marketing-section">
        <div className="marketing-container">
          <div className="hero-stack hero-stack--start">
            <HeroTitle className="newsroom-hero__title">Newsroom</HeroTitle>
            <p className="newsroom-hero__lead">
              Company announcements, media coverage, and updates from Podium Markets.
            </p>
          </div>
        </div>
      </section>

      {featuredNewsroomItem ? (
        <section className="marketing-section newsroom-featured-section">
          <div className="marketing-container">
            <h2 className="newsroom-section__title">Featured</h2>
            <NewsroomFeaturedCard item={featuredNewsroomItem} />
          </div>
        </section>
      ) : null}

      <section className="marketing-section newsroom-list-section">
        <div className="marketing-container">
          <h2 className="newsroom-section__title">All News</h2>
          <NewsroomTable items={newsroomItems} />
        </div>
      </section>
    </main>
  )
}
